<template>
  <div class="myload">
    <!-- 下拉刷新 -->
    <van-pull-refresh
      class="van-pull-refresh"
      v-model="isLoading"
      :head-height="200"
      @refresh="onRefresh"
    >
      <div class="myload_box">
        <!-- 我的融资头部tab切换 -->
        <div class="myload_head">
          <my-load-head
            :activeIndex="activeIndex"
            @setActiveIndex="setActiveIndex"
          ></my-load-head>
        </div>

        <!-- 已授信，未授信 -->
        <div class="myload_content">
          <my-load-left
            v-if="activeIndex === 0"
            :creditSuccessList="creditSuccessList"
          ></my-load-left>
          <my-load-right
            v-if="activeIndex === 1"
            :creditFailureList="creditFailureList"
            :activeIndex="activeIndex"
          ></my-load-right>
          <my-load-right
            v-if="activeIndex === 2"
            :creditFailureList="aggsList"
            :activeIndex="activeIndex"
          ></my-load-right>
        </div>
      </div>
    </van-pull-refresh>
    <!-- 浮窗按钮 -->
    <floating-window></floating-window>
  </div>
</template>

<script>
import FloatingWindow from '@/components/FloatingWindow.vue';
import MyLoadHead from './components/MyLoadHead.vue';
import MyLoadLeft from './components/MyLoadLeft.vue';
import MyLoadRight from './components/MyLoadRight.vue';

export default {
  name: 'myLoad',
  components: {
    MyLoadHead,
    MyLoadLeft,
    MyLoadRight,
    FloatingWindow,
  },
  data() {
    return {
      count: 0,
      isLoading: false,
      activeIndex: 0,
      creditFailureList: [],
      creditSuccessList: [],
      aggsList:[]
    };
  },
  mounted() {
    this.getOrderList();
    this.getAggsList();
    if(this.$route.query.activeIndex){
      this.setActiveIndex(parseInt(this.$route.query.activeIndex))
      this.$router.replace({})
    }
  },
  methods: {
    onRefresh() {
      this.getOrderList();
      this.getAggsList();
    },
    setActiveIndex(i) {
      this.activeIndex = i;
    },
    getOrderList() {
      this.$api.PublicPage.getOrderList()
        .then((res) => {
          if (res.success) {
            const { data } = res;
            this.creditFailureList = data.creditFailureList;
            this.creditSuccessList = data.creditSuccessList;
          } else {
            this.$dialog.alert({
              title: '提示',
              message: res.returnMessage,
            });
          }
          this.isLoading = false;
        })
        .catch((e) => {
          this.$dialog.alert({
            title: '提示',
            message: e,
          });
        });
    },
    getAggsList() {
      this.$api.PublicPage.getAggsList()
        .then((res) => {
          if (res.success) {
            const { data } = res;
            this.aggsList = data;
          } else {
            this.$dialog.alert({
              title: '提示',
              message: res.returnMessage,
            });
          }
          this.isLoading = false;
        })
        .catch((e) => {
          this.$dialog.alert({
            title: '提示',
            message: e,
          });
        });
    },
  },
};
</script>
<style scoped>
.myload {
  width: 100%;
  height: 100%;
}
.myload_box {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.myload_content {
  background: #f8f8f9;
  flex: 1;
}
.van-pull-refresh {
   height: calc(100vh) !important;
   overflow: auto !important;
}
</style>
